


import { Component, Vue } from 'vue-property-decorator';
import { Preset } from '@/utils/api';
import { namespace } from 'vuex-class';

const homeModule = namespace('home');

@Component({})
export default class PresetNavigation extends Vue {
  @homeModule.State private presets!: Preset[];
  @homeModule.State private currentPresetIndex!: number;
  @homeModule.Getter private numberOfPresets!: number;
  @homeModule.Getter private isLastPreset!: boolean;
  @homeModule.Getter private isFirstPreset!: boolean;
  @homeModule.Action private increaseCurrentIndex!: () => void;
  @homeModule.Action private decreaseCurrentIndex!: () => void;

  private get highlightBarWidth(): number {
    return (1 / this.numberOfPresets) * 100;
  }

  private get highlightBarPosition(): number {
    return this.currentPresetIndex * 100;
  }

  private goToNext(): void {
    if (!this.isLastPreset) {
      this.increaseCurrentIndex();
    }
  }

  private goToPrevious(): void {
    if (!this.isFirstPreset) {
      this.decreaseCurrentIndex();
    }
  }
}
